/**
 * TBA Container Component (Full dnd-kit Conversion)
 * Renders courses with TBA or unrecognized times
 */
import { memo, useContext } from 'react';
import ReactTimetableContext from '../context/ReactTimetableContext';
import DraggableCourseBox from './DraggableCourseBox';
import StaticCourseBox from './StaticCourseBox';
import styles from './TbaContainer.module.css';

const TbaContainer = memo(({
    tbaBoxes: suppliedTbaBoxes,
    virtualBoxes: suppliedVirtualBoxes,
    readOnly = false,
}) => {
    const context = useContext(ReactTimetableContext);
    const tbaBoxes = suppliedTbaBoxes || context.tbaBoxes;
    const virtualBoxes = suppliedVirtualBoxes || context.virtualBoxes;

    // Filter virtual boxes for TBA sections only
    const virtualTbaBoxes = virtualBoxes?.filter(box => box.type === 'tba') || [];

    const allTbaBoxes = [...(tbaBoxes || []), ...virtualTbaBoxes];
    const CourseBox = readOnly ? StaticCourseBox : DraggableCourseBox;

    return (
        <div
            className={styles.container}
        >
            {allTbaBoxes.length === 0 ? (
                <div className={styles.empty}>No TBA courses</div>
            ) : (
                allTbaBoxes.map((box, index) => (
                    <CourseBox
                        key={`${box.occurrenceId}-${box.isVirtual ? 'virtual' : 'real'}-${index}`}
                        {...box}
                        timeStart={box.start}
                        timeEnd={box.end}
                        readOnly={readOnly}
                    />
                ))
            )}
        </div>
    );
});

TbaContainer.displayName = 'TbaContainer';

export default TbaContainer;
